import React from "react";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";
import clsx from "clsx";

import { makeStyles, withStyles } from "@material-ui/core/styles";

import { Step, Stepper, StepConnector, StepLabel } from "@material-ui/core";

import Add from "@material-ui/icons/Add";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Receipt from "@material-ui/icons/Receipt";
import Print from "@material-ui/icons/Print";
import { AccountBalance, Description } from "@material-ui/icons";

import { STEPPER_EXPEDIENTE_CONTABLES_FORM, STEPPER_EXPEDIENTE_CONTABLES_PROFORMA_FORM, STEPPER_EXPEDIENTE_FORM, STEPPER_EXPEDIENTE_PROFORMA_FORM } from "../../../utils/constants";

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;
  const { menuProforma, proformas } = useSelector(state => state.mesaEntrada);
  const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);

  let icons;
  if(menuProforma && proformas.length > 0){
    if(cuentas.length > 1){
      icons = {
        1: <Receipt />,
        2: <Description />,
        3: <Add />,
        4: <AccountBalance />,
        5: <AssignmentIcon />,
        6: <Print />,
      }
    }else{
      icons = {
        1: <Receipt />,
        2: <Description />,
        3: <Add />,
        4: <AssignmentIcon />,
        5: <Print />,
      }
    }
  }else{
    if(cuentas.length > 1){
      icons = {
        1: <Receipt />,
        2: <Add />,
        3: <AccountBalance />,
        4: <AssignmentIcon />,
        5: <Print />,
      }
    }else{
      icons = {
        1: <Receipt />,
        2: <Add />,
        3: <AssignmentIcon />,
        4: <Print />,
      }
    }
  }

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: 10,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonRoot: {
    margin: 25,
  },
  rootListadoc: {
    margin: 25,
  },
}));

export const MesaEntradaStepper = (props) => {
  const classes = useStyles();
  const { menuProforma, proformas } = useSelector(state => state.mesaEntrada);
  const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);

  let { activeStep = menuProforma && proformas.length > 0 
    ? (cuentas.length > 1 ? STEPPER_EXPEDIENTE_CONTABLES_PROFORMA_FORM.TRAMITE_COMPROBANTE : STEPPER_EXPEDIENTE_PROFORMA_FORM.TRAMITE_COMPROBANTE)
    : (cuentas.length > 1 ? STEPPER_EXPEDIENTE_CONTABLES_FORM.TRAMITE_COMPROBANTE : STEPPER_EXPEDIENTE_FORM.TRAMITE_COMPROBANTE)
  } = props;

  let steps;
  if(props.menuPrestador){
    if(cuentas.length > 1){
      steps = [
        "Tramite Comprobante",
        "Guardar Comprobante",
        "Asignacion Cuentas Contables",
        "Guardar Documentación Comprobante",
        "Imprimir Comprobante"
      ]
    }else{
      steps = [
        "Tramite Comprobante",
        "Guardar Comprobante",
        "Guardar Documentación Comprobante",
        "Imprimir Comprobante"
      ]
    }
  }else{
    steps = [
      "Tramite Comprobante",
      "Guardar Comprobante",
      "Guardar Documentación Comprobante"
    ]
  }

  if(menuProforma && proformas.length > 0){
    if(cuentas.length > 1){
      steps = [
        "Tramite Comprobante",
        "Proformas Pendientes",
        "Guardar Comprobante",
        "Asignacion Cuentas Contables",
        "Guardar Documentación Comprobante",
        "Imprimir Comprobante"
      ]
    }else{
      steps = [
        "Tramite Comprobante",
        "Proformas Pendientes",
        "Guardar Comprobante",
        "Guardar Documentación Comprobante",
        "Imprimir Comprobante"
      ] 
    }
  }

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
